import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import type { BookingsReviewList } from "@msuite/utils/types";
import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";

/**
 * The host's queue: settlement records whose partner booked hours nobody has answered yet. The
 * route gates on `read Partner`, so the query waits for that rule rather than collecting a
 * refusal for a caller without it.
 */
export function usePendingReviewBookings() {
	/** Hooks */
	const { organization, citadel } = useAuth();

	/** Query */
	const queryKey = ["partner-bookings", "pending-review", guardString(organization.id)];
	const query = useQuery({
		queryKey,
		queryFn: async () => {
			const response = await client.organizations[":orgId"].partnerships.bookings[
				"pending-review"
			].$get({
				param: { orgId: guardString(organization.id) },
			});
			const data = await responseHandler(response);
			return data.bookings as BookingsReviewList;
		},
		enabled: citadel?.can("read", "Partner") === true,
	});

	/** Return */
	return { ...query, bookings: query.data ?? [], queryKey };
}
